export default "__VITE_ASSET___ZKjOrLc__"